// extracted by mini-css-extract-plugin
export default {"select":"App_select__UUjEW","clear":"App_clear__3JiAi"};